import { render } from "./numberPool.vue?vue&type=template&id=a8f3532c&scoped=true"
import script from "./numberPool.vue?vue&type=script&lang=js"
export * from "./numberPool.vue?vue&type=script&lang=js"

import "./numberPool.vue?vue&type=style&index=0&id=a8f3532c&scoped=true&lang=css"
import "./numberPool.vue?vue&type=style&index=1&id=a8f3532c&lang=css"
script.render = render
script.__scopeId = "data-v-a8f3532c"

export default script